module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/19-684977460ab0059e1ddfab0623cb977f.png";